/* eslint-disable */

import 'babel-polyfill';
import './polyfills/querySelectorAll';
import React, { Component } from 'react';
import * as Scroll from 'react-scroll';
import './App.scss';
import Header from './components/header';
import Landing from './components/landing';
import VehicleNav from './components/vehicleNav';
import SearchTabs from './components/searchTabs';
import Results from './components/results/results';
import { withRouter } from 'react-router-dom';
import { translate } from 'react-i18next';
import store from './store';
import ReactGA from 'react-ga';
import { parse } from 'qs';

const Fragment = React.Fragment;
const language = store.getState().content.language;

class App extends Component {
  constructor(props) {
    super(props);
    const { location, i18n, t } = this.props;
    if (language == 'ru') {
      window.location.href = 'https://productselector.eame.mobil.com/'
    }

    if (['is', 'fr-be', 'nl-be'].indexOf(i18n.language) === -1) {
      i18n.changeLanguage(this.props.location.pathname.replace('/', ''));
    }

  }

  state = {
    backgroundLoaded: false,
    searchOnly: false,
  };

  componentDidMount() {
    Scroll.animateScroll.scrollToTop();
    this.preloadBackgrounds();
    this.loadCurrentBackground();
  }

  loadCurrentBackground = () => {
    const backgroundImage = this.getBackgroundImage();
    const img = new Image();
    img.onload = () => {
      this.setState({ backgroundLoaded: true });
    };
    img.src = backgroundImage;
  };

  componentDidUpdate(prevProps, prevState) {

    if (this.state.selectedTabId) {
      const id = this.state.selectedTabId;
      if (!this.state.equipment) {
        ReactGA.event({
          category: this.props.i18n.language,
          action: id.charAt(0).toUpperCase() + id.slice(1),
        });
      }

      if (!this.state.trackedSearch) {
        this.setState({ trackedSearch: true });
        Scroll.animateScroll.scrollToTop();
        ReactGA.pageview('search');
        ReactGA.event({ category: 'Landing', action: 'B2B' });
      }
    }

    if (this.state.equipment) {
      if (!this.state.trackedResults) {
        this.setState({ trackedResults: true });
        window.scrollTo(0, 0);
        ReactGA.pageview('results');
      }
    }

    if (prevState.selectedTabId !== this.state.selectedTabId) {
      this.setState({ backgroundLoaded: false });
      this.loadCurrentBackground();
    }
  }

  preloadBackgrounds = () => {
    const backgrounds = [
      '/images/backgrounds/cars.jpg',
      '/images/backgrounds/vans.png',
      '/images/backgrounds/commercial.png',
      '/images/backgrounds/agricultural.png',
      '/images/backgrounds/off-highway.png'
    ];

    backgrounds.forEach(src => {
      const img = new Image();
      img.src = src;
    });
  };

  backToSearch = (selectedFamily, searchOnly) => {
    this.setState({
      equipment: null,
      selectedTabId: selectedFamily,
      searchOnly: searchOnly,
      isSearching: false,
    });
  };

  getData = (data) => {
    this.setState(data);
  };

  updateHeader = (value) => {
    this.setState({ header: value });
  };

  handleSearchComplete = (isSearching) => {
    this.setState({ isSearching });
  };

  getBackgroundImage = () => {
    const vehicleType = this.state.selectedTabId || 'cars';
    const backgroundMap = {
      'cars': '/images/backgrounds/cars.jpg',
      'vans': '/images/backgrounds/vans.png',
      'commercial': '/images/backgrounds/commercial.png',
      'agricultural': '/images/backgrounds/agricultural.png',
      'off-highway': '/images/backgrounds/off-highway.png'
    };
    return backgroundMap[vehicleType] || '/images/backgrounds/cars.jpg';
  };

  render() {
    const backgroundImage = this.getBackgroundImage();
    const bgStyle = {
      '--bg-image': `url(${backgroundImage})`
    };
    const appClass = `App${this.state.backgroundLoaded ? ' loaded' : ''}`;

    const landing = (
      <section className={appClass} style={{ ...bgStyle, minHeight: '100vh' }}>
        <Landing showMainApp={this.getData} />
      </section>
    );

    const search = (
      <Fragment>
        {!this.state.isSearching && (
          <VehicleNav
            updateHeader={this.updateHeader}
            searchOnly={this.getData}
            selectedFamily={this.getData}
            currentFamily={this.state.selectedTabId}
            searchOnlyValue={this.state.searchOnly}
          />
        )}
        <SearchTabs
          equipment={this.getData}
          searchOnly={this.state.searchOnly}
          selectedFamily={this.state.selectedTabId}
          onSearchComplete={this.handleSearchComplete}
          equipmentState={this.state.equipment}
        />
      </Fragment>
    );

    const results = (
      <Results
        updateHeader={this.updateHeader}
        backToSearch={this.backToSearch}
        equipment={this.state.equipment}
        cvl={this.state.searchOnly}
        selectedFamily={this.state.selectedTabId}
      />
    );

    const mainApp = (
      <section className={`${appClass}${this.state.equipment ? ' has-results' : ''} ${this.state.selectedTabId || 'cars'}`} style={{ ...bgStyle, minHeight: '100vh' }}>
        <Header header={this.state.header} selectedFamily={this.state.selectedTabId} />
        {this.state.equipment ? results : search}
      </section>
    );

    return this.state.showMainApp ? mainApp : landing;
  }
}

export default withRouter(translate('translations')(withRouter(App)));
